import { rightArrow } from "@simplybusiness/icons";
import { NextAction as NextActionComponent } from "./NextAction";
import type { NextActionProps } from "./types";
import { useEnvironmentValues } from "../../../../../hooks/environment";

export const NextAction = (props: NextActionProps) => {
  const { site } = useEnvironmentValues();

  if (site === "moneysupermarket") {
    return <NextActionComponent {...props} icon={rightArrow} iconSize="sm" />;
  }

  return <NextActionComponent {...props} />;
};

export type { NextActionProps } from "./types";
